import { formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppointmentService } from '../../services/appointment.service';

@Component({
  selector: 'app-appointments',
  templateUrl: './appointments.component.html',
  styleUrls: ['./appointments.component.scss'],
})
export class AppointmentsComponent implements OnInit {
  title!: string;

  constructor(
    private http: HttpClient,
    private appointmentService: AppointmentService,
    private authService: AuthenticationService,
    private spinner:NgxSpinnerService
  ) {}

  value: String = 'Upcoming';
  appointments: any = [];
  userRole: any;
  show:boolean=false
  ngOnInit(): void {
    this.show=false;
    this.spinner.show()
    let location=null;
    let diagId=null
    let status="REVIEWED";
    this.userRole = this.authService.getUserType();
    this.title = "Test Ready Appointments";
    // if (this.userRole == 'ADMIN' && this.userRole == 'DIRECTOR') {
    //   this.title = 'Ongoing Appointments';
    // } else {
    //   diagId=this.authService.getUserId()
    //   this.title = "Upcoming Appointments";
    // }
    const today =  new Date();
    const todayDate = formatDate(today, 'yyyy-MM-dd', 'en-US');
    const nextweek = formatDate(new Date(today.setDate(today.getDate() + 7)), 'yyyy-MM-dd', 'en-US');
    this.appointmentService.getAppointments(location,diagId,status,null,todayDate,nextweek).subscribe(res=>{
      this.appointments=res.data;
      this.show=true;
      this.spinner.hide()

    })
  }
  getAppointments() {}
  selectValue(value: string) {
    this.value = value;
  }
}
